import ClipboardData from './clipboardData';

export default class PasteEvent {
  constructor() {
    this.clipboardData = new ClipboardData();
  }
}



// WEBPACK FOOTER //
// src/plugins/copyPaste/pasteEvent.js